import { EVENTS } from "./constants";
import { ActiveVehicle } from "./types";

window.vehicleManager.pubsub.subscribe(
  EVENTS.vehicleChange,
  (data: ActiveVehicle) => {
    document.body.dataset.activeVehicle = data ? "true" : "false";
  },
  { replayLast: true },
);
